import {isInApp} from '../../../utils/user-agent';
import {getSettings} from '../../selectors';

export default state => !!(isInApp() && getSettings(state)?.should_hide_flex_in_app);